import { render, staticRenderFns } from "./MyReservation.vue?vue&type=template&id=23731994&"
import script from "./MyReservation.vue?vue&type=script&lang=ts&"
export * from "./MyReservation.vue?vue&type=script&lang=ts&"
import style0 from "./MyReservation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports